import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 6,
	height: 6,
	viewBox: "0 0 6 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 2.96289H6.0008",
		stroke: "#99BCDF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3 0.185059L3 5.74061",
		stroke: "#99BCDF"
	})]
});
export default SvgPlusIcon;
